interface Props {
  stagingBuilderID: number;
  newFileNumber: number;
  editedOn: number;
}
export const updateFileNumber = ({
  stagingBuilderID,
  newFileNumber,
  editedOn,
}: Props): StagingBuilderReducer => {
  return {
    type: "UPDATE_STAGINGBUILDER_META",
    payload: { stagingBuilderID, editedOn, fileNumber: newFileNumber },
  };
};
